import formatNumber from '@i18n/formatNumber'

export default function DeliveryFeeText({address, deliveryFee}) {
  if (!address) return 'Por calcular'
  if (deliveryFee === 0) return 'Gratis'
  return formatNumber(deliveryFee, 'money')
}
